import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DialogiModule } from '@enauka/dialogi';
import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './login/login.component';
import { RenewPasswordDialogComponent } from './renew-password-dialog/renew-password-dialog.component';
import { ServiceUnavailableComponent } from './service-unavailable/service-unavailable.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AuthRoutingModule,
    DialogiModule
  ],
  declarations: [LoginComponent, RenewPasswordDialogComponent, ServiceUnavailableComponent],
  exports: [LoginComponent]
})
export class SharedAuthFeatureLoginModule { }
